/**
 * Updates the cart item count bubble and aria-label in the header.
 * Listens for cart:updated events to keep the count in sync.
 */
import { Component } from "@theme/component";

class CartIcon extends Component {
  setup() {
    this.countEl = this.$("[data-cart-count]");
    this.trigger = this.$("button, a");
    document.addEventListener("cart:updated", (e) => this.update(e.detail));
  }

  update(detail) {
    if (detail?.item_count === undefined) return;

    const count = detail.item_count;

    if (this.countEl) {
      // Write the count into the inner sticker span so the pink-pill wrapper
      // survives. Fall back to the outer textContent if the inner span isn't
      // there (e.g. a future markup change drops it).
      const inner = this.countEl.querySelector("span");
      if (inner) {
        inner.textContent = count;
      } else {
        this.countEl.textContent = count;
      }
      // Use the .is-empty class (paired with the CSS rule in header.liquid)
      // instead of the `hidden` attribute so both the initial Liquid render
      // path and the JS update path agree on how the badge is hidden.
      this.countEl.classList.toggle("is-empty", count === 0);

      // Trigger the Y2K sticker-spin pop on update.
      this.countEl.setAttribute("data-just-changed", "1");
      setTimeout(() => this.countEl.removeAttribute("data-just-changed"), 700);
    }

    // Update aria-label with current count
    if (this.trigger) {
      const label = count === 1 ? "Cart, 1 item" : `Cart, ${count} items`;
      this.trigger.setAttribute("aria-label", label);
    }
  }
}

customElements.define("cart-icon", CartIcon);

export { CartIcon };
